import React from 'react';
import LandingPage from './LandingPage';
import CustomerRegistration from './CustomerRegistration';

function Router() {
  // Simple routing based on URL path
  const path = window.location.pathname;
  
  // Match /creg or /creg-{code}
  if (path.includes('/creg')) {
    // Extract code from path like /creg-abc123
    const match = path.match(/\/creg(?:-([a-zA-Z0-9]+))?/);
    const code = match && match[1] ? match[1] : null;
    return <CustomerRegistration code={code} />;
  }
  
  return <LandingPage />;
}

export default Router;